import { capitalize, flatten } from "lodash";

import {
  AdType,
  FacebookCampaignObjective,
  IFacebookCampaign,
} from "screens/adLibrary/facebookUtils/types";
import { IAd } from "shared/types/adLibrary";

export const returnTitleFromCampaignObjective = (
  campaignObjective: FacebookCampaignObjective,
) =>
  campaignObjective
    .split("_")
    .map(part => capitalize(part))
    .join(" ");

export const returnCanAdBeLoadedToCampaign = (
  ad: IAd,
  campaign: IFacebookCampaign,
) => {
  switch (campaign.objective) {
    case FacebookCampaignObjective.VIDEO_VIEWS:
      return AdType.Video === ad.type;
    case FacebookCampaignObjective.PRODUCT_CATALOG_SALES:
      return [AdType.AIA, AdType.DPA, AdType.FTA].includes(ad.type);
    case FacebookCampaignObjective.LINK_CLICKS:
    case FacebookCampaignObjective.CONVERSIONS:
    case FacebookCampaignObjective.REACH:
    case FacebookCampaignObjective.OUTCOME_TRAFFIC:
    case FacebookCampaignObjective.OUTCOME_AWARENESS:
    case FacebookCampaignObjective.OUTCOME_SALES:
    case FacebookCampaignObjective.OUTCOME_LEADS:
      return ![AdType.AIA, AdType.DPA, AdType.FTA].includes(ad.type);
    default:
      return false;
  }
};

export const returnAdsetsFromCampaignData = (campaigns: IFacebookCampaign[]) =>
  flatten(campaigns.map(campaigns => campaigns.adsets?.data ?? []));
